/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */

import genericStyles from "../../Styles/genericStyles.module.css";
import MUIDataTableCustomStyle from "../../Components/MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState, createContext } from "react";
import { endpoints } from "../../Utils/UrlEnum";
import { AutocompleteChangeReason, Button, Chip, Box } from "@mui/material";
import { ProductsModel } from "../../Utils/Models";
import { ETableEditAction, EWidths } from "../../Utils/Enums";
import GenericModal from "../GenericModal";
import { FormsIds, TablesIds } from "../../Utils/Constants";
import ServicesForm from "./ServicesForm";
import useCustomMemo from "../../Hooks/useCustomMemo";

export const CRUDContext = createContext(new ProductsModel());

export default function ServicesTable() {
  const [contextValue, setContextValue] = useState(new ProductsModel());
  const [open, setOpen] = useState(false);
  const [triggerReload, setTriggerReload] = useState<undefined | boolean>();
  const memo = useCustomMemo();
  const examCategories = memo.storage.examCategories;

  const instructorColumns = [
    {
      label: `${Vocabulary.name}`,
      name: "name",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.price}`,
      name: "prices",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          if (!value || !Array.isArray(value) || value.length === 0) {
            return "-";
          }
          return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {value.map((priceEntry: any, index: number) => (
                <Chip
                  key={index}
                  label={`${priceEntry.workPointId.name}: ${priceEntry.price ?? 0} RON`}
                  size="small"
                  sx={{ fontSize: '0.75rem' }}
                />
              ))}
            </Box>
          );
        },
      },
    },
    {
      label: `${Vocabulary.supplementaryHourPrice}`,
      name: "supplementaryHoursPrices",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          if (!value || !Array.isArray(value) || value.length === 0) {
            return "-";
          }
          return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {value.map((priceEntry: any, index: number) => (
                <Chip
                  key={index}
                  label={`${priceEntry.workPointId.name}: ${priceEntry.price ?? 0} RON`}
                  size="small"
                  sx={{ fontSize: '0.75rem' }}
                />
              ))}
            </Box>
          );
        },
      },
    },
    {
      label: `${Vocabulary.documents}`,
      name: "documentTypes",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          if (!value || !Array.isArray(value) || value.length === 0) {
            return "-";
          }
          return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {value.map((docType: any, index: number) => (
                <Chip
                  key={index}
                  label={docType?.name || docType}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Box>
          );
        },
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          onEditAction={ETableEditAction.MODAL}
          title={Vocabulary.services}
          columns={instructorColumns}
          CRUDEndPoint={endpoints.product.main}
          id={TablesIds.product}
          handleModalForm={setOpen}
          addOrEditForm={
            <GenericModal
              onClose={() => {
                setOpen(false);
                setContextValue(new ProductsModel());
              }}
              maxWidth={EWidths.MD}
              open={open}
              actions={
                <div className={genericStyles.modalActions}>
                  <Button
                    color="secondary"
                    onClick={() => {
                      setOpen(false);
                      setContextValue(new ProductsModel());
                    }}
                    variant="outlined"
                    fullWidth
                  >
                    {Vocabulary.cancel}
                  </Button>
                  <Button
                    fullWidth
                    type="submit"
                    form={FormsIds.productForm}
                    variant="contained"
                  >
                    {Vocabulary.save}
                  </Button>
                </div>
              }
              title={Vocabulary.editModalTitle}
            >
              <ServicesForm
                setContextValue={(
                  e: any,
                  client: ProductsModel | null,
                  reason: AutocompleteChangeReason,
                  details?: any
                ) => ({})}
                onClose={() => {
                  setOpen(false);
                  setTriggerReload(
                    triggerReload !== undefined ? !triggerReload : false
                  );
                  setContextValue(new ProductsModel());
                }}
                examCategories={examCategories}
              />
            </GenericModal>
          }
          setContextValue={setContextValue}
          triggerReload={triggerReload}
        />
      </CRUDContext.Provider>
    </div>
  );
}
